import { Link } from 'react-router-dom';
import DonateSection from '../components/DonateSection';
import './Home.css';

const quickLinks = [
  {
    to: '/about',
    emoji: '👧',
    label: 'Our Story',
    desc: 'Meet Emmi and her sister Izzi',
    color: 'lavender',
  },
  {
    to: '/learn',
    emoji: '📚',
    label: 'Learn',
    desc: 'Discover different ways kids experience the world',
    color: 'mint',
  },
  {
    to: '/events',
    emoji: '📅',
    label: 'Events',
    desc: 'Find fun inclusive activities near you',
    color: 'peach',
  },
  {
    to: '/forum',
    emoji: '💬',
    label: 'Share Your Story',
    desc: 'Tell us about your experience',
    color: 'blue',
  },
];

const funFacts = [
  { emoji: '🌟', text: '1 in 6 kids has a developmental disability' },
  { emoji: '💬', text: 'Many kids communicate in amazing and creative ways' },
  { emoji: '🤝', text: 'Inclusive friendships make everyone happier' },
  { emoji: '🧠', text: 'Every brain is unique and special' },
];

export default function Home() {
  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero-bg-shapes">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
          <div className="shape shape-4" />
        </div>
        <div className="container hero-content">
          <div className="hero-text fade-in">
            <div className="hero-badge">💜 Made with love by Emmi, age 8</div>
            <h1 className="hero-title">
              Welcome to<br />
              <span className="gradient-text">Special and Beyond!</span>
            </h1>
            <p className="hero-tagline">
              Learning to understand, include, and celebrate every child. ✨
            </p>
            <p className="hero-desc">
              Hi! I'm Emmi, and I made this website for my sister Izzi and all
              the other amazing kids who experience the world in their own special
              way. This is a place for kids to learn, share, and become better
              friends to everyone around them!
            </p>
            <div className="hero-buttons">
              <Link to="/about" className="btn btn-primary">Meet Emmi & Izzi 👧</Link>
              <Link to="/learn" className="btn btn-outline">Start Learning 📚</Link>
            </div>
          </div>
          <div className="hero-illustration" aria-hidden="true">
            <div className="hero-circle">
              <div className="hero-emoji-group">
                <span className="big-emoji float-1">💜</span>
                <span className="big-emoji float-2">🌟</span>
                <span className="big-emoji float-3">🌈</span>
                <span className="big-emoji float-4">🤝</span>
                <span className="big-emoji float-5">🌸</span>
                <span className="center-emoji">✨</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Banner */}
      <section className="mission-banner">
        <div className="container">
          <div className="mission-inner">
            <span className="mission-icon">🌍</span>
            <p>
              <strong>Our Mission:</strong> Every child deserves to be understood,
              included, and celebrated — no matter how their brain works or how
              they move through the world.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Links */}
      <section className="section">
        <div className="container">
          <h2 className="section-title text-center">Explore the Site 🗺️</h2>
          <p className="section-subtitle text-center">
            Click any section to start your journey!
          </p>
          <div className="quick-links-grid">
            {quickLinks.map(link => (
              <Link key={link.to} to={link.to} className={`quick-card quick-card-${link.color}`}>
                <span className="quick-emoji">{link.emoji}</span>
                <h3>{link.label}</h3>
                <p>{link.desc}</p>
                <span className="quick-arrow">→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Fun Facts */}
      <section className="section facts-section">
        <div className="container">
          <h2 className="section-title text-center">Did You Know? 🤔</h2>
          <p className="section-subtitle text-center">
            Here are some cool things to think about!
          </p>
          <div className="facts-grid">
            {funFacts.map((fact, i) => (
              <div key={i} className="fact-card">
                <span className="fact-emoji">{fact.emoji}</span>
                <p>{fact.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to become an Inclusion Champion? 🏆</h2>
            <p>
              Learning about how different kids experience the world is the first
              step to being an amazing friend. Let's go!
            </p>
            <div className="cta-buttons">
              <Link to="/learn" className="btn btn-primary">Start Learning 📚</Link>
              <Link to="/forum" className="btn btn-secondary">Share Your Story 💬</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Donate */}
      <DonateSection />
    </div>
  );
}
